export const ENUM_CARD_TYPE = {
    LINK: 'LINK',
    POST: 'POST',
    EMBED: 'EMBED',
    TEXT: 'TEXT',
    SEPARATOR: 'SEPARATOR',
    POSTS: 'POSTS',
};
//# sourceMappingURL=card-type.enum.js.map